import API from './classes/API';

export const wgAuthApi = new API({
  baseURL: process.env.REACT_APP_AUTH_HOST!,
});
